// Dependencies
import striptags from 'striptags';

const calculateWordCount = (text) => {
  const plainText = striptags(text);
  const words = plainText.trim().split(/\s+/).length;

  return words;
};

export default calculateWordCount;
